(function() {

    'use strict';
    angular.module('app')
        .controller('activateAccountController', ['$scope', '$routeParams', '$location', 'accountsService', activateAccountController]
            );

    function activateAccountController($scope, $routeParams, $location, accountsService) {
        $scope.model = {};

        accountsService.activate($routeParams.t)
            .then(function() {
                $scope.model.complete = true;
            });

        $scope.redirectToLogin = function() {
            if ($routeParams.ct != undefined) {
                $location.url('/login?ct=' + window.encodeURIComponent($routeParams.ct));
            } else {
                $location.url('/login');
            }
        };
    }
})();